class GraphQLEndpoints {
  constructor(endpoints) {
    this.endpoints = endpoints;
  }
  // Create a support
  static create(config) {
    const { id, title, url, method = "POST", fetchApi } = config;
    return {
      id,
      title,
      fetcher: async (params, options = {}) => {
        const body = JSON.stringify(params);
        const headers = {
          "Content-Type": "application/json",
          ...config.headers,
          ...options.headers
        };
        const res = await (fetchApi?.fetch ?? fetch)(await url, {
          method,
          headers,
          body
        });
        return res.json();
      }
    };
  }
  /**
   * Creates a GitHub GraphQL endpoint that uses the GithubAuth API to authenticate requests.
   *
   * If a request requires more permissions than is granted by the existing session,
   * the fetcher will automatically ask for the additional scopes that are required.
   */
  static github(config) {
    const {
      id,
      title,
      url = "https://api.github.com/graphql",
      errorApi,
      fetchApi,
      githubAuthApi
    } = config;
    return {
      id,
      title,
      fetcher: async (params, options = {}) => {
        let retried = false;
        const doRequest = async () => {
          const res = await (fetchApi?.fetch ?? fetch)(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${await githubAuthApi.getAccessToken()}`,
              ...options.headers
            },
            body: JSON.stringify(params)
          });
          if (!res.ok) {
            throw new Error(
              `Request failed with status ${res.status} ${res.statusText}`
            );
          }
          const data = await res.json();
          if (!data.errors || retried) {
            return data;
          }
          retried = true;
          const missingScopes = data.errors.filter(({ type }) => type === "INSUFFICIENT_SCOPES").flatMap(({ message }) => {
            const scopesMatch = message.match(
              /one of the following scopes: (\[.*?\])/
            );
            if (!scopesMatch) {
              return [];
            }
            try {
              const scopes = JSON.parse(scopesMatch[1].replace(/'/g, '"'));
              return scopes;
            } catch (error) {
              if (errorApi) {
                errorApi.post(
                  new Error(
                    `Failed to parse scope string "${scopesMatch[1]}", ${error}`
                  )
                );
              }
              return [];
            }
          });
          await githubAuthApi.getAccessToken(missingScopes);
          return doRequest();
        };
        return await doRequest();
      }
    };
  }
  static from(endpoints) {
    return new GraphQLEndpoints(endpoints);
  }
  async getEndpoints() {
    return this.endpoints;
  }
}

export { GraphQLEndpoints };
//# sourceMappingURL=GraphQLEndpoints.esm.js.map
